import React, { Fragment } from 'react'
import { Collapsible, CollapsibleHeader, CollapsibleContent } from 'react-components'

import { AnalyticsService } from '@src/services'
import { homePageEventCategories } from '@src/services/analytics-service/categories'
import { homePageEventLabels } from '@src/services/analytics-service/labels'

import {
    TitleContainer,
    TitleContent,
    TitleIconUp,
    TitleIconDown,
    CellContainer,
    DescriptionContainer,
} from './faq-cell-styles'

interface Props {
    title: string
    description: string
}

const _handleFAQTitleClick = () => {
    AnalyticsService.trackClickEvent(homePageEventCategories.FAQ_SECTION, homePageEventLabels.faqSection.SHOW_MORE)
}

const FAQCell: React.FC<Props> = ({ title, description }) => (
    <CellContainer>
        <Collapsible initialOpen={false} transitionTime={300}>
            {({ isOpened }) => (
                <Fragment>
                    <CollapsibleHeader>
                        <TitleContainer onClick={_handleFAQTitleClick}>
                            <TitleContent>{title}</TitleContent>

                            {isOpened && <TitleIconUp alt="Up Logo" />}
                            {!isOpened && <TitleIconDown alt="Down Logo" />}
                        </TitleContainer>
                    </CollapsibleHeader>
                    <CollapsibleContent>
                        <DescriptionContainer inputText={description} />
                    </CollapsibleContent>
                </Fragment>
            )}
        </Collapsible>
    </CellContainer>
)

export default FAQCell
